module.exports = __webpack_public_path__ + "static/img/bg-change-block-very-small.61f5b0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-change-block-very-small.png
// module id = TQMu
// module chunks = 0